import createCachedSelector from 're-reselect';

import { BannerId } from '../../typings/banners';
import {
    EditedBannerImage,
    getEditedBannerWithImage,
    MassActionId
} from '../../typings/bannersEditState';
import { BannerImageSize, BannerImageType } from '../../typings/domain';
import { State } from '../../typings/state';

import { getEditedBannerCacheKey, selectEditedBanner } from './banner';

export const selectEditedBannerImage = (
    state: State,
    bannerId: BannerId
): EditedBannerImage => {
    const image = state.imageEditor[bannerId].image || {};
    if (bannerId === MassActionId.bannersEdit) {
        return image;
    }

    const banner = getEditedBannerWithImage(
        selectEditedBanner(state, bannerId)
    );
    if (!banner) {
        throw new Error(
            `failed to select image for banner ${bannerId}: invalid type`
        );
    }
    return image;
};

export const selectEditedBannerImageSize = createCachedSelector(
    selectEditedBannerImage,
    (image: EditedBannerImage): BannerImageSize | undefined => {
        const imageData = image.data;

        return (
            imageData && {
                width: imageData.width,
                height: imageData.height,
                isAdaptive: imageData.isAdaptive
            }
        );
    }
)(getEditedBannerCacheKey);

export const selectEditedBannerImageType = createCachedSelector(
    selectEditedBannerImage,
    (image: EditedBannerImage): BannerImageType | undefined => {
        const imageData = image.data;

        return imageData && imageData.type;
    }
)(getEditedBannerCacheKey);

export const selectEditedBannerImageUrl = createCachedSelector(
    selectEditedBannerImage,
    (image: EditedBannerImage): string | undefined => {
        const imageData = image.data;

        return imageData && imageData.url;
    }
)(getEditedBannerCacheKey);
